import React from 'react';

import { flagStyles } from '../settings';

const SvgBJ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-552px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBJ;
